import { AdvancedSettingsService } from '../../../services'

const saveSMSProviders = async function (
  { commit, state, getters, dispatch },
  config
) {
  const { locationId, payload } = config
  commit('startLoading')
  try {
    const data = await AdvancedSettingsService.saveConversationChannels(locationId, payload)
    return Promise.resolve(data)
  } catch (error) {
     return Promise.reject(error)
  } finally{
    commit('stopLoading')
  }
}

export default saveSMSProviders
